import React, { useState } from 'react'
import styled from 'styled-components'
import Logo from './Logo'
import Facebook from '../Icons/Facebook'
import Twitter from '../Icons/Twitter'
import Pi from '../Icons/Pi'
import MailMail from '../Icons/MailMail'


const Section = styled.section`
width:100vw;
background-color: ${props => props.theme.body};
`

const Navbar = styled.nav`
display:flex;
justify-content: space-between;
align-items: center;

width:85%;
height:${props => props.theme.navHeight};
margin: 0 auto;

.desktop{
    display: none;
}

@media (min-width: 64rem) {
    .desktop{
        display: none;
    }
    .mobile{
        display: inline-block;
    }
}
`

const Menu = styled.ul`
display: flex;
justify-content:space-between;
align-items:center;
list-style:none;

@media (max-width: 64em) {
    position: fixed;
    top:${props => props.theme.navHeight};
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: ${props => `calc(100vh - ${props.theme.navHeight})`};
    z-index: 50;
    background-color: ${props => `rgba(${props.theme.bodyRgba}, 0.85)`};
    backdrop-filter: blur(2px);

    transform: ${props => props.click ? 'translateY(0)' : 'translateY(1000%)'};
    transition: all 0.3s ease;
    justify-content: center;

    flex-direction: column;
    justify-content: center;

    touch-action: none;


}
`

const MenuItem = styled.li`
margin:0 1rem;
color:${props => props.theme.text};
cursor: pointer;

&::after{
    content: ' ';
    display: block;
    width: 0%;
    height: 2px;
    background: ${props => props.theme.text};
    transition: width 0.3s ease;
}
&:hover::after{
    width: 100%;
}

@media (max-width: 64em) {
    margin: 1rem 0;

    &::after{
        display: none;
    }
}
`

const HamBurgerMenu = styled.span`
width: ${props => props.click ? '2rem' : '1.5rem'};
height: 2px;
background: ${props => props.theme.text};

position: absolute;
top: 2rem;
left: 50%;
transform: ${props => props.click ? 'translateX(-50%) rotate(90deg)' : 'translateX(-50%) rotate(0)'};

display: none;
justify-content: center;
align-items: center;

cursor: pointer;
transition: all 0.3s ease;

@media (max-width: 64em) {
    display: flex;
}

&::after, &::before{
    content: ' ' ;
    width: ${props => props.click ? '1rem' : '1.5rem'};
    height: 2px;
    right: ${props => props.click ? '-2px' : '0'};
    background: ${props => props.theme.text};
    position: absolute;
    transition: all 0.3s ease;
}

&::after{
    top: ${props => props.click ? '0.3rem' : '0.5rem'};
    transform: ${props => props.click ? 'rotate(-40deg)' : 'rotate(0)'};
}

&::before{
    bottom: ${props => props.click ? '0.3rem' : '0.5rem'};
    transform: ${props => props.click ? 'rotate(40deg)' : 'rotate(0)'};
}
`

const IconList = styled.div`
display: flex;
align-items: center;
justify-content: center;
margin: 1rem auto;
margin-left: 300px;

&>*{
    padding-right: 0.5rem;
    transition: all 0.2s ease;
}

@media (max-width: 48em){
    margin-left: 20px;
}
`
const Helper = styled.div`
margin-bottom: 6px;
`



const Navigation = () => {

    const [click, setClick] = useState(false);

const scrollTo = (id) => {

    let element = document.getElementById(id);

    element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
    })

    setClick(!click)

}


    return (
        <Section id="navigation">
            <Navbar>
                <Logo/>

                <HamBurgerMenu  click={click} onClick={() => setClick(!click)}>
                    &nbsp;
                </HamBurgerMenu>

        
                <Menu click={click}>
                    <MenuItem onClick={() => scrollTo('home')} >Home</MenuItem>
                    <MenuItem onClick={() => scrollTo('about')} >About</MenuItem>
                    <MenuItem onClick={() => scrollTo('roadmap')} >My Skills</MenuItem>
                    <MenuItem onClick={() => scrollTo('showcase')} >Slides</MenuItem>
                    <MenuItem onClick={() => scrollTo('team')} >Art Gallery</MenuItem>
                    <MenuItem onClick={() => scrollTo('faq')} >Biography</MenuItem>
                    <MenuItem onClick={() => scrollTo('hire')} >Hire Me</MenuItem>
                    <MenuItem >
                    <div className="mobile">
                    <IconList>
                        <a href="https://www.instagram.com/sylvenshi/?igshid=YmMyMTA2M2Y%3D" target="_blank" rel="noopener noreferrer">
                            <Facebook /></a>

                            <a href="https://ko-fi.com/sylvenshi" target="_blank" rel="noopener noreferrer">
                            <Pi /></a>

                            <a href="https://twitter.com/sylvenshi" target="_blank" rel="noopener noreferrer">
                            <Twitter /></a>

                            <a href="mailto:sylvenshi@gmail.com" target="_blank" rel="noopener noreferrer">
                            <MailMail /></a>

                            <a href="https://www.etsy.com/shop/rubeemart" target="_blank" rel="noopener noreferrer">
                                <Helper>
                            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24"><path d="M10 19.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5zm3.5-1.5c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm6.304-15l-3.431 12h-2.102l2.542-9h-16.813l4.615 11h13.239l3.474-12h1.929l.743-2h-4.196z"/></svg>
                            </Helper>
                            </a>
                    </IconList>
                    </div>
                    </MenuItem>
                </Menu>

                <div className="desktop">
                <IconList>
                        <a href="https://www.instagram.com/sylvenshi/?igshid=YmMyMTA2M2Y%3D" target="_blank" rel="noopener noreferrer">
                            <Facebook /></a>

                            <a href="https://ko-fi.com/sylvenshi" target="_blank" rel="noopener noreferrer">
                            <Pi /></a>

                            <a href="https://twitter.com/sylvenshi" target="_blank" rel="noopener noreferrer">
                            <Twitter /></a>

                            <a href="mailto:sylvenshi@gmail.com" target="_blank" rel="noopener noreferrer">
                            <MailMail /></a>

                            <a href="https://www.etsy.com/shop/rubeemart" target="_blank" rel="noopener noreferrer">
                            <Helper>
                            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24"><path d="M10 19.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5zm3.5-1.5c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm6.304-15l-3.431 12h-2.102l2.542-9h-16.813l4.615 11h13.239l3.474-12h1.929l.743-2h-4.196z"/></svg>
                            </Helper>
                            </a>
                    </IconList>
                </div>
            </Navbar>
        </Section>
    )
}

export default Navigation